// extracted by mini-css-extract-plugin
export default {"dynamic-split-layout":"scmEUJ","dynamicSplitLayout":"scmEUJ"};